const get = form => {
	if (!form) return form;
	return form.map(f => ({
		...f,
		currency: form.currency.code,
	}));
};

export default get;
